export const ContactAssignment = {
    Manual: "MANUAL-ASSIGN",
    Automatic: "ACD"
};
